import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils';
import { AlgorithmMappingQueryDtoSchema } from './AlgorithmMappingQueryDtoSchema';
import { AlgorithmMappingQueryDtoType } from './types';

export const AlgorithmMappingsQueryDtoSchema = z.object({
  algorithmId: z.number(),
  mappings: transformNullish<
    AlgorithmMappingQueryDtoType[],
    AlgorithmMappingQueryDtoType[]
  >(AlgorithmMappingQueryDtoSchema.array(), []),
});
